import { render } from "./PlusMinus.vue?vue&type=template&id=19f63014&scoped=true&ts=true"
import script from "./PlusMinus.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlusMinus.vue?vue&type=script&setup=true&lang=ts"

import "./PlusMinus.vue?vue&type=style&index=0&id=19f63014&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f63014"],['__file',"src/components/PlusMinus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19f63014"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19f63014', __exports__)) {
    api.reload('19f63014', __exports__)
  }
  
  module.hot.accept("./PlusMinus.vue?vue&type=template&id=19f63014&scoped=true&ts=true", () => {
    api.rerender('19f63014', render)
  })

}


export default __exports__